<template>
  <div class="shotlist">
    <PageLoader :isActive="isLoading"/>
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <router-link :to="'/jobs/edit/' + eventId" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x2">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </router-link>
          <div class="h6">
            {{ eventData.event_name }}
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <h2>Shots</h2>
            <div class="button-group">
              <router-link :to="'/jobs/' + eventId + '/shots/create'" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mr-x2 desktop-button">
                <i class="fas fa-plus mr-x1"></i>Add a Shot
              </router-link>
              <button class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline desktop-button" @click="uploadCSVmodal = true">
                <i class="fas fa-file-csv mr-x1"></i>Upload Shots CSV
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col-md-8 col-lg-6">
          <div class="zero-card mb-x2" v-for="(shot, index) in shots" :key="index">
            <div v-if="shot.general">
              <p class="pre-wrap">{{ shot.notes }}</p>
            </div>
            <div v-else>
              <p class="shot-date">{{ parseDate(shot.date) }}</p>
              <h5>{{ amPmConvert(shot.start_time) }} - {{ amPmConvert(shot.end_time) }}</h5>
              <CreativesList includeName v-if="users.length !== 0" :allUsers="users" :creatives="shot.creatives" />
              <div class="shot-info-group" v-if="shot.location">
                <div class="shot-label">location</div>
                <p>{{ shot.location }}</p>
              </div>
              <div class="shot-info-group" v-if="shot.event">
                <div class="shot-label">event/session</div>
                <p>{{ shot.event }}</p>
              </div>
              <div class="shot-info-group" v-if="shot.contact">
                <div class="shot-label">session contact</div>
                <p>{{ shot.contact }}</p>
              </div>
              <div class="shot-info-group" v-if="shot.notes">
                <div class="shot-label">CSV notes</div>
                <p class="pre-wrap">{{ shot.notes }}</p>
              </div>
              <div class="shot-info-group" v-if="shot.extraone">
                <div class="shot-label">Added notes</div>
                <p class="pre-wrap">{{ shot.extraone }}</p>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <router-link :to="'/jobs/' + eventId + '/shots/edit/' + shot.id" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-tertiary d-block">
                <i class="fas fa-pen mr-x1"></i>Edit
              </router-link>
              <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-tertiary d-block" @click="verifyDelete = shot.id">
                <i class="fas fa-trash mr-x1"></i>Delete
              </button>
            </div>
          </div>
          <hr class="mt-x4 mb-x4">
          <h5 class="color-danger mb-x2">Danger Zone</h5>
          <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline d-block" @click="verifyDeleteAll = true">
            <i class="fas fa-trash mr-x1"></i>Delete All Shots
          </button>
        </div>
      </div>
    </div>
    <!-- FABS -->
    <router-link :to="'/jobs/' + eventId + '/shots/create'" class="zero-btn zero-btn-fab zero-btn-primary bottom-right mobile-button">
      <i class="fas fa-plus"></i>
    </router-link>
    <button @click="uploadCSVmodal = true" class="zero-btn zero-btn-fab zero-btn-primary bottom-right mobile-button csv-fab">
      <i class="fas fa-file-csv"></i>
    </button>
    <!-- modal town -->
    <!-- CSV modal -->
    <div class="modal-container" :class="{ 'show-modal' : uploadCSVmodal }">
      <div class="modal-card zero-form">
        <h4>Upload Days CSV</h4>
        <p class="mb-x2">Add a CSV file to bulk add shots. Use the <a href="/samples/shotlist-example.xlsx" download>sample shotlist XLSX file</a> as a template.</p>
        <p class="mb-x2">Once your shotlist is ready, <span class="underline">you must export it as a CSV before uploading it</span>.</p>
        <div class="input-block mb-x2">
          <label for="image-input">
            <div class="label-inner">file</div>
            <div class="file-drag-drop" @dragover="fileDragOver" @dragleave="fileDragLeave" @drop="fileDrop">
              Drag a single file for upload
            </div>
          </label>
          <input
            type="file"
            id="csv-input"
            name="csv-input"
            ref="csvinput"
            placeholder=""
            class="standard-text-input mb-x2"
            :class="{ 'has-error': errors.file }"
            autocomplete="off"
            @change="fileInputChange"
            accept=".pdf,.jpg,.jpeg,.png,.csv"
          >
        </div>
        <button class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline width-100 mb-x2" @click="uploadCSV()">
          <i class="fas fa-file-csv mr-x1"></i>Upload this CSV
        </button>
        <button class="zero-btn zero-btn-standard zero-btn-tertiary zero-btn-outline width-100" @click="uploadCSVmodal = false">
          Cancel
        </button>
      </div>
    </div>
    <!-- delete modal -->
    <div class="modal-container" :class="{ 'show-modal' : verifyDelete }">
      <div class="modal-card">
        <h4>Delete this shot?</h4>
        <p class="mb-x4">This action cannot be undone.</p>
        <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline width-100 mb-x2" @click="deleteShot(verifyDelete)">
          <i class="fas fa-trash mr-x1"></i>Delete this shot
        </button>
        <button class="zero-btn zero-btn-standard zero-btn-tertiary zero-btn-outline width-100" @click="verifyDelete = ''">
          Cancel
        </button>
      </div>
    </div>
    <!-- delete all modal -->
    <div class="modal-container" :class="{ 'show-modal' : verifyDeleteAll }">
      <div class="modal-card">
        <h4>Delete all shots</h4>
        <p class="mb-x4">This action cannot be undone.</p>
        <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline width-100 mb-x2" @click="deleteAllShots()">
          <i class="fas fa-trash mr-x1"></i>Delete all shots
        </button>
        <button class="zero-btn zero-btn-standard zero-btn-tertiary zero-btn-outline width-100" @click="verifyDeleteAll = false">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import CreativesList from '@/components/CreativesList.vue'
import PageLoader from '@/components/PageLoader.vue'
import shared from '@/shared.js'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    CreativesList,
    PageLoader
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      eventId: '',
      eventData: {
        'event_name': '',
        'start_date': '',
        'end_date': '',
        'location': '',
        'floorplan_path': ''
      },
      shots: [],
      uploadCSVmodal: false,
      errors: {
        'file': ''
      },
      users: [],
      verifyDelete: '',
      verifyDeleteAll: false
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.eventid) {
      this.isLoading = true
      this.eventId = this.$route.params.eventid
      this.getEvent()
      this.getShots()
    }
  },
  methods: {
    getEvent () {
      axios
        .get(apiChoice + 'api/events/' + this.eventId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.eventData = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    getShots () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/events/' + this.eventId + '/shots', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.shots = response.data
          this.getUsers()
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getUsers () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/users', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          this.users = response.data
        })
        .catch((error) => {
          console.log(error.response.data)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    uploadCSV () {
      this.isLoading = true
      let formData = new FormData()
      if (document.getElementById('csv-input').value !== '') {
        formData.append('csv', document.getElementById('csv-input').files[0])
      } else {
        formData.append('csv', null)
      }
      formData.append('id', this.eventId)
      axios
        .post(apiChoice + 'api/events/' + this.eventId + '/shots/csv', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.uploadCSVmodal = false
          this.getShots()
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    parseDate (timestamp, dateSegment = 0) {
      return shared.parseDate(timestamp, dateSegment, true)
    },
    amPmConvert (time) {
      return shared.amPmConvert(time)
    },
    fileInputChange () {
      // I think for single file upload this isn't necessary...
      this.inputFile = this.$refs.csvinput.files
    },
    fileDragOver (event) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('drag-on-active')) {
        event.currentTarget.classList.add('drag-on-active')
      }
    },
    fileDragLeave (event) {
      // Clean up
      event.currentTarget.classList.remove('drag-on-active')
    },
    fileDrop (event) {
      event.preventDefault()
      this.$refs.csvinput.files = event.dataTransfer.files
      this.fileInputChange() // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.remove('drag-on-active')
    },
    deleteShot (shotid) {
      axios
        .delete(apiChoice + 'api/shots/' + shotid, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.verifyDelete = ''
          this.getShots()
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    deleteAllShots () {
      axios
        .delete(apiChoice + 'api/events/' + this.eventId + '/shots', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.verifyDeleteAll = false
          this.getShots()
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}
.desktop-button{
  display: none;
}
.mobile-button {
  display: flex;
  &.csv-fab{
    right: 100px;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .desktop-button{
    display: inline-block;
  }
  .mobile-button {
    display: none;
  }
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
